var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.179,
    height: 54.081,
    viewBox: "0 0 53.179 54.081",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.442,0H81.98a3.606,3.606,0,0,0-3.605,3.605V25.238h1.8V3.605a1.8,1.8,0,0,1,1.8-1.8h41.462a1.8,1.8,0,0,1,1.8,1.8V39.659a1.8,1.8,0,0,1-1.8,1.8H104.514v1.8h18.928a3.606,3.606,0,0,0,3.605-3.605V3.605A3.606,3.606,0,0,0,123.442,0Zm0,0",
    transform: "translate(-73.618)",
    fill: "#f90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.875,62.5h1.8v1.8h-1.8Zm0,0",
    transform: "translate(-132.513 -58.895)",
    fill: "#f90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.375,62.5h1.8v1.8h-1.8Zm0,0",
    transform: "translate(-191.408 -58.895)",
    fill: "#f90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.875,62.5h1.8v1.8h-1.8Zm0,0",
    transform: "translate(-250.302 -58.895)",
    fill: "#f90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.875,125h41.462v1.8H140.875Zm0,0",
    transform: "translate(-132.513 -117.789)",
    fill: "#f90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.875,213.04a.9.9,0,0,0,.9.9h10.816a.9.9,0,0,0,.9-.9v-7.211a.9.9,0,0,0-.9-.9h-4.134l-1.539-1.539a.9.9,0,0,0-.637-.264h-4.507a.9.9,0,0,0-.9.9Zm1.8-8.112h3.232l1.539,1.539a.9.9,0,0,0,.637.264h3.605v5.408h-9.013Zm0,0",
    transform: "translate(-132.513 -191.408)",
    fill: "#f90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.494,205.829a.9.9,0,0,0-.9-.9h-4.134l-1.539-1.539a.9.9,0,0,0-.637-.264h-4.507a.9.9,0,0,0-.9.9v9.013a.9.9,0,0,0,.9.9h10.816a.9.9,0,0,0,.9-.9Zm-1.8,6.309h-9.013v-7.211h3.232l1.539,1.539a.9.9,0,0,0,.637.264h3.605Zm0,0",
    transform: "translate(-368.091 -191.408)",
    fill: "#f90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.494,205.829a.9.9,0,0,0-.9-.9h-4.134l-1.539-1.539a.9.9,0,0,0-.637-.264h-4.507a.9.9,0,0,0-.9.9v9.013a.9.9,0,0,0,.9.9h10.816a.9.9,0,0,0,.9-.9Zm-1.8,6.309h-9.013v-7.211h3.232l1.539,1.539a.9.9,0,0,0,.637.264h3.605Zm0,0",
    transform: "translate(-603.67 -191.408)",
    fill: "#f90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.158,462.138v1.8h3.605a.9.9,0,0,0,.9-.9v-7.211a.9.9,0,0,0-.9-.9H442.63l-1.539-1.539a.9.9,0,0,0-.637-.264h-2.7v1.8h2.331l1.539,1.539a.9.9,0,0,0,.637.264h3.605v5.408Zm0,0",
    transform: "translate(-412.262 -426.986)",
    fill: "#f90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.592,454.928h-4.134l-1.539-1.539a.9.9,0,0,0-.637-.264h-4.507a.9.9,0,0,0-.9.9v9.013a.9.9,0,0,0,.9.9h10.816a.9.9,0,0,0,.9-.9v-7.211A.9.9,0,0,0,652.592,454.928Zm-.9,7.211h-9.013v-7.211h3.232l1.539,1.539a.9.9,0,0,0,.637.264h3.605Zm0,0",
    transform: "translate(-603.67 -426.986)",
    fill: "#f90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.534,448.316H1.151a.9.9,0,0,0-.9.9v5.408a.9.9,0,0,0,.9.9H3.534a11.664,11.664,0,0,0,.712,1.722l-1.684,1.684a.9.9,0,0,0,0,1.275l3.824,3.824a.9.9,0,0,0,1.275,0l1.683-1.684a11.667,11.667,0,0,0,1.722.712v2.382a.9.9,0,0,0,.9.9h5.408a.9.9,0,0,0,.9-.9v-2.382A11.667,11.667,0,0,0,20,462.347l1.683,1.684a.9.9,0,0,0,1.275,0l3.824-3.824a.9.9,0,0,0,0-1.275L25.1,457.248a11.663,11.663,0,0,0,.712-1.722h2.382a.9.9,0,0,0,.9-.9v-5.408a.9.9,0,0,0-.9-.9H25.809a11.663,11.663,0,0,0-.712-1.722l1.684-1.684a.9.9,0,0,0,0-1.275l-3.824-3.824a.9.9,0,0,0-1.275,0L20,441.5a11.667,11.667,0,0,0-1.722-.712V438.4a.9.9,0,0,0-.9-.9H11.967a.9.9,0,0,0-.9.9v2.382a11.667,11.667,0,0,0-1.722.712l-1.683-1.684a.9.9,0,0,0-1.275,0l-3.824,3.824a.9.9,0,0,0,0,1.275l1.684,1.684c-.075.146-.147.295-.216.444A11.705,11.705,0,0,0,3.534,448.316Zm1.549,1.127a9.833,9.833,0,0,1,1.055-2.549A.9.9,0,0,0,6,445.8l-1.525-1.525,2.55-2.55,1.525,1.525a.9.9,0,0,0,1.1.139,9.855,9.855,0,0,1,2.549-1.055.9.9,0,0,0,.676-.872V439.3h3.605v2.158a.9.9,0,0,0,.676.872,9.855,9.855,0,0,1,2.549,1.055.9.9,0,0,0,1.1-.139l1.525-1.525,2.55,2.55L23.344,445.8a.9.9,0,0,0-.139,1.1,9.855,9.855,0,0,1,1.055,2.549.9.9,0,0,0,.872.676H27.29v3.605H25.132a.9.9,0,0,0-.872.676,9.854,9.854,0,0,1-1.055,2.549.9.9,0,0,0,.139,1.1l1.525,1.525-2.55,2.55-1.525-1.525a.9.9,0,0,0-1.1-.139,9.851,9.851,0,0,1-2.549,1.055.9.9,0,0,0-.676.873v2.158H12.869v-2.158a.9.9,0,0,0-.676-.873,9.851,9.851,0,0,1-2.549-1.055.9.9,0,0,0-1.1.139l-1.525,1.525-2.55-2.55L6,458.044a.9.9,0,0,0,.139-1.1A9.854,9.854,0,0,1,5.083,454.4a.9.9,0,0,0-.872-.676H2.053v-3.605H4.21A.9.9,0,0,0,5.083,449.443Zm0,0",
    transform: "translate(0 -412.262)",
    fill: "#f90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.184,590.744a6.309,6.309,0,1,0-6.309-6.309A6.309,6.309,0,0,0,147.184,590.744Zm0-10.816a4.507,4.507,0,1,1-4.507,4.507A4.507,4.507,0,0,1,147.184,579.928Zm0,0",
    transform: "translate(-132.513 -544.775)",
    fill: "#f90000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderManagement);
export default __webpack_public_path__ + "static/media/folder-management.6b0460cbe3f87be3aa2d7c854ca7939c.svg";
export { ForwardRef as ReactComponent };